<template>
  <div class="verval">
    <v-row dense class="pa-4 white--text mb-4 mt-3" style="background-color: #39C57B; margin: 0 1px">
      <v-col cols="12" lg="7" class="my-auto">
        <div class="body-1"> Pilih sekolah untuk <strong>Peserta Pelatihan Pengimbasan</strong> </div>
      </v-col>
      <v-col cols="12" lg="5" class="text-right">
        <v-menu>
          <template v-slot:activator="{ attrs, on }">
            <v-btn depressed style="background-color: #FDFFCF; border-radius: 5pt" v-bind="attrs" v-on="on">
              <v-row dense>
                <v-col cols="10" class="text-left">
                  <p class="black--text my-auto">
                    {{ sekolah.nama || '-' }}
                  </p>
                </v-col>
                <v-col cols="2" class="my-auto">
                  <v-icon right dark>mdi-chevron-down</v-icon>
                </v-col>
              </v-row>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item-group v-model="idSekolahPilih" color="primary">
              <template v-for="(item, key) in sekolahs">
                <v-divider v-if="key !== 0" :key="`divider-${key}`"></v-divider>
                <v-list-item :key="key" :value="key" link>
                  <v-list-item-title>{{ $getDeepObj(item, 'sekolah.nama') }}</v-list-item-title>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
    <v-alert
      v-if="!!$getDeepObj(pelatihanAjuan, 'ajuan.wkt_ajuan')"
      icon="mdi-information"
      close-text="Tutup"
      colored-border
      border="left"
      type="info"
      class="bg-notif ma-0 my-2"
      color="yellow darken-2"
    >
      Perubahan data terakhir pada tanggal
      <span class="font-weight-medium">
        {{ $localDate($getDeepObj(pelatihanAjuan, 'ajuan.wkt_ajuan'), false, true) }} WIB</span
      >
      oleh {{ $isObject($getDeepObj(pelatihanAjuan, 'ajuan.akun')) ? 'Admin BGP' : 'Kepala Sekolah' }}
      <span class="font-weight-medium">{{
        $isObject($getDeepObj(pelatihanAjuan, 'ajuan.akun'))
          ? $getDeepObj(pelatihanAjuan, 'ajuan.akun.nama')
          : $getDeepObj(pelatihanAjuan, 'ajuan.ptk.nama')
      }}</span>
    </v-alert>
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row class="bg-kiri" no-gutters>
          <v-col cols="2" class="mt-5"></v-col>
          <v-col cols="10" class="pa-5" style="background-color: white">
            <h1 class="headline info--text">
              <v-row dense>
                <v-col cols="12" md="7">
                  Peserta Pelatihan Pengimbasan
                </v-col>
              </v-row>
            </h1>
            <div class="body-2 black--text mt-2 mb-4">
              Pelatihan pengimbasan dibutuhkan sebagai persiapan sekolah sebelum melakukan pengimbasan. Maka dari itu,
              sebaiknya guru yang dipilih mengikuti Pelatihan Pengimbasan merupakan Peserta PKP (Pelatihan Komite
              Pembelajaran)
            </div>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left px-0">
                      <h3 class="title orange--text">
                        Status
                      </h3>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="px-0">
                      <v-row no-gutters class="py-2">
                        <v-col cols="10" md="7">
                          Memilih Peserta Pelatihan
                        </v-col>
                        <v-col cols="2" md="5">
                          <v-icon
                            class="mr-5"
                            :color="
                              statusLabel[
                                $getDeepObj(pelatihanAjuan, 'ajuan.k_verval_psp') >= 2 ? 'passed' : 'not_complete'
                              ].color
                            "
                          >
                            {{
                              statusLabel[
                                $getDeepObj(pelatihanAjuan, 'ajuan.k_verval_psp') >= 2 ? 'passed' : 'not_complete'
                              ].icon
                            }}
                          </v-icon>
                        </v-col>
                      </v-row>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <div class="grey lighten-4 black--text pa-2" style="font-size: 0.8rem; border-radius: 5px">
              <b>Keterangan Status :</b> <br />
              <i class="v-icon notranslate mdi mdi-check-circle theme--light success--text" style="font-size: 1rem" />
              &nbsp;Tahapan sudah diselesaikan<br />
              <i
                class="v-icon notranslate mdi mdi-alert-circle theme--light grey--text grey-lighten-2"
                style="font-size: 1rem"
              />
              &nbsp; Tahapan belum diselesaikan
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-tabs v-if="$isObject(pengimbasan)" v-model="tab" grow centered @change="onChangeTab">
      <v-tab :disabled="item.disabled" v-for="(item, i) in tabItems" :key="i" class="text-capitalize">
        {{ item.title }}
      </v-tab>
      <v-tab-item class="mt-2" v-for="(item, i) in tabItems" :key="i">
        <ListData
          ref="index"
          :endpoint="item.key"
          :pengimbasan="pengimbasan"
          :meta="meta"
          :list="listData"
          :pelatihan-ajuan="pelatihanAjuan"
          @reload="onReload"
        />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ListData from './Index.vue';
export default {
  components: { ListData },
  data() {
    return {
      tab: 0,
      tabItems: [
        { title: 'Ajuan Peserta Pengimbasan', key: 'fetch' },
        { title: 'Daftar Guru dan Kepala Sekolah', key: 'candidate' },
      ],
      gelombang: 1,
      statusLabel: {
        passed: { icon: 'mdi-check-circle', color: 'success' },
        not_complete: { icon: 'mdi-alert-circle', color: 'grey' },
      },
      sekolah: {},
      sekolahs: [],
      idSekolahPilih: 0,
      pengimbasan: {},
      meta: {},
      listData: [],
      pelatihanAjuan: {},
    };
  },
  computed: {
    ...mapState('preferensi', {
      ptk: (state) => state.data?.ptk ?? {},
    }),
  },
  created() {
    this.tab = 0;
    this.fetchIndex();
  },
  methods: {
    ...mapActions('pengimbasan', ['index', 'fetch', 'candidate']),

    async fetchIndex() {
      const params = { gelombang: this.gelombang };

      // index
      const { data, meta } = await this.index({ params });

      this.sekolahs = data;
      this.pengimbasan = this.sekolahs[this.idSekolahPilih] || {};
      this.sekolah = this.pengimbasan['sekolah'] || {};
      this.meta = meta;

      this.$nextTick(() => {
        this.fetchData();
      });
    },

    async fetchData(tab) {
      if (this.tab === 0 || tab === 0) {
        const data = await this.fetch({ id: this.pengimbasan.psp_pelatihan_ajuan_id });
        const pspPelatihanKandidats = this.$getDeepObj(data, 'ajuan.psp_pelatihan_kandidats') || [];

        this.pelatihanAjuan = data;
        this.listData = pspPelatihanKandidats.map((kandidat) =>
          Object.assign(
            {},
            kandidat.ptk,
            { mapel_ajar: kandidat.mapel_ajar },
            { is_kasek: this.$getDeepObj(data, 'ajuan.ptk_id') === kandidat.ptk_id }
          )
        );
      } else {
        this.listData = await this.candidate({ id: this.pengimbasan.psp_pelatihan_ajuan_id });
      }
    },

    onChangeTab() {
      this.$nextTick(() => {
        this.fetchData();
      });
    },

    onReload() {
      this.fetchData(0);
    },

    onChangeSekolah(id) {
      this.pengimbasan = this.sekolahs[id] || {};
      this.sekolah = this.pengimbasan['sekolah'] || {};

      this.$nextTick(() => {
        this.fetchData();
      });
    },
  },
  watch: {
    idSekolahPilih: 'onChangeSekolah',
  },
};
</script>
<style>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
